import { call, put, takeLatest } from 'redux-saga/effects';

import {
    PUBLIC_CONFIGURATION_INIT,
    // PUBLIC_CONFIGURATION_INIT_FAIL,
    PUBLIC_CONFIGURATION_INIT_SUCCESS,
} from '../actions/config';
import ConfigApi from '../api/config';
import Bugsnag from '../bugsnag';

function createPublicConfigurationInitialization() {
    return function* (actions) { // eslint-disable-line consistent-return
        try {
            const data = yield call(ConfigApi.getPublicConfiguration);
            const actionSuccess = {
                type: PUBLIC_CONFIGURATION_INIT_SUCCESS,
                payload: {
                    ...data,
                    hash: actions.payload.hash,
                },
            };
            yield put(actionSuccess);
        } catch (error) {
            Bugsnag.notify(error);
        }
    };
}

export const initializePublicConfiguration = createPublicConfigurationInitialization();

/**
 * @function initializePublicConfigWatcher "listener" to the PUBLIC_CONFIGURATION_INIT action
 */
export function* initializePublicConfigurationWatcher() {
    yield takeLatest(PUBLIC_CONFIGURATION_INIT, initializePublicConfiguration);
}

/**
 * expose "listeners"
 */
export default [
    initializePublicConfigurationWatcher(),
];
